import React from 'react'
import { Button } from 'react-bootstrap'

const Buttons = ({
    className,
    size,
    clickEvent,
    btnLabel,
    btnIcon,
    variant,
    dir,
    style,
    handleKeyPress,
    isDisbled
}) => {
    return (
        <>
            <Button
                className={className}
                size={size}
                onClick={clickEvent}
                variant={variant}
                style={{ height: '37px', ...style }}
                onKeyDown={handleKeyPress}
                disabled={isDisbled}
            >
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '5px',
                        fontSize: '13px',
                        lineHeight:"19px"
                    }}
                >
                    {btnLabel} <span>{btnIcon}</span>
                </div>
            </Button>
        </>
    )
}
export default Buttons
